import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/facebook-constant";

export {
    addTargeting,
    addSingleTargeting,
    updateSingleTargeting,
    getSingleTargeting,
    getAllTargeting,
    searchTargeting,
    searchTargetingWithSearchCriteria,
    prepareTargetingList
}

const collectionName = 'facebook-targeting';
const collectionReference = collection(fireStoreDB, collectionName);

const addTargeting = (targeting) => {
    return Promise.map(targeting, async targeting => {
        await addSingleTargeting(targeting);
    });
}

const addSingleTargeting = (targeting) => {
    targeting.createdAt = new Date();
    targeting.updatedAt = targeting.createdAt;
    return addDoc(collectionReference, targeting);
}

const updateSingleTargeting = (targeting) => {
    const documentReference = doc(fireStoreDB, collectionName, targeting.id);
    targeting.updatedAt = new Date();
    return setDoc(documentReference, targeting);
}

const getSingleTargeting = async (targetingId) => {
    const documentReference = doc(fireStoreDB, collectionName, targetingId);
    const targetingDoc = await getDoc(documentReference);
    return prepareSingleTargeting(targetingDoc);
}

const getAllTargeting = async () => {
    let searchQuery = query(collectionReference);
    const targetingResult = await getDocs(searchQuery);
    return prepareTargetingList(targetingResult);
}

const searchTargeting = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const targetingResult = await getDocs(searchQuery);
    return prepareTargetingList(targetingResult);
}

const searchTargetingWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchTargetingWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const targetingResult = await getDocs(searchQuery);
    return prepareTargetingList(targetingResult);
}

const prepareTargetingList = (targetingResult) => {
    const targetingList = [];

    _.forEach(targetingResult.docs, targetingDoc => {
        targetingList.push(prepareSingleTargeting(targetingDoc));
    });

    return targetingList;
}


const prepareSingleTargeting = (targetingDoc) => {
    const targeting = targetingDoc.data();
    targeting.id = targetingDoc.id;
    return targeting;
}
